import { ClientCartAction, ClientCartActionCartRef, SwarovskiOptikClientCart } from "@swo/storefront";
import { MyCartAction_RemoveFromCart } from "../../../types";
import { Either } from "fp-ts/es6/Either";
import { performCartAction } from "../perform-cart-action";

import { SwarovskiOptikErrorClientResponse } from "../../types";

export const removeFromCart = (
  token: string,
  localeCode: string,
  segmentKey: string,
  _cartRef: ClientCartActionCartRef,
  lineItems: MyCartAction_RemoveFromCart["lineItems"],
): Promise<Either<SwarovskiOptikErrorClientResponse, SwarovskiOptikClientCart>> => {
  const cartRef: ClientCartActionCartRef = {
    id: _cartRef.id,
    version: _cartRef.version,
  };

  const actionBody: ClientCartAction = {
    tag: "remove-from-cart",
    cartRef,
    changes: lineItems.map(li =>
      li.data.tag === "bundle"
        ? { tag: "bundle", correlationId: li.data.correlationId }
        : { tag: li.data.tag, lineItemId: li.id },
    ),
  };

  return performCartAction(token, localeCode, segmentKey)(actionBody);
};
